import type { PlanRolesQuery } from '@affine/graphql';
import {
  catchErrorInto,
  effect,
  Entity,
  fromPromise,
  LiveData,
  mapInto,
  onComplete,
  onStart,
  smartRetry,
} from '@toeverything/infra';
import { exhaustMap } from 'rxjs';

import type { SubscriptionStore } from '../stores/subscription';

/**
 * The plans the platform relies on by role (plan rows, `plan_role`): the base
 * plan of a tenant without a plan subscription and the demo workspace plan.
 */
export class PlanRoles extends Entity {
  roles$ = new LiveData<PlanRolesQuery['planRoles'] | null>(null);
  basePlan$ = this.roles$.map(roles => roles?.basePlan ?? null);
  demoPlan$ = this.roles$.map(roles => roles?.demoPlan ?? null);
  isRevalidating$ = new LiveData(false);
  error$ = new LiveData<any | null>(null);

  constructor(private readonly store: SubscriptionStore) {
    super();
  }

  revalidate = effect(
    exhaustMap(() =>
      fromPromise(signal => this.store.fetchPlanRoles(signal)).pipe(
        smartRetry(),
        mapInto(this.roles$),
        catchErrorInto(this.error$),
        onStart(() => this.isRevalidating$.next(true)),
        onComplete(() => this.isRevalidating$.next(false))
      )
    )
  );
}
